import { render, staticRenderFns } from "./ModalAddMOTMVotes.vue?vue&type=template&id=1adff0e0&"
import script from "./ModalAddMOTMVotes.vue?vue&type=script&lang=js&"
export * from "./ModalAddMOTMVotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports